import { useTranslations } from 'next-intl';
import BgContainer from '@components/BgContainer';
import QueryLink from '@components/QueryLink';

export default function BannerFrontTopAuction() {
  const t = useTranslations('Banners.BannerFrontTopAuction');
  return (
    <BgContainer grow={true}>
      <div className='items-strech flex w-full flex-wrap items-center justify-between py-2 text-lg md:flex-nowrap'>
        <div className='border-l-2 border-brand px-4 py-2 pr-0 md:mr-6'>
          <h1 className='mb-2 text-xl font-bold md:text-2xl lg:text-3xl'>
            {t('title')}
          </h1>
          <div className='max-w-[50em]'>{t('content')}</div>
        </div>
      </div>
    </BgContainer>
  );
}
